// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { ProductLoading } from '../../../../elements/Product/Product';
import { groupItems } from '../../../new-order/QuoteStep/utils';
import { animateScroll as scroll } from 'react-scroll/modules';
import update from 'immutability-helper';
import Product from '../../../../elements/Product/Product';
import ReservedContainer from '../reserved/containers/ReservedContainer';
import ReceivedContainer from '../received/containers/ReceivedContainer';
import DeliverContainer from '../deliver/containers/DeliverContainer';
import PurchasedContainer from '../purchased/containers/PurchasedContainer';
import CompletedContainer from '../completed/containers/CompletedContainer';
import SaleSummary, { SaleSummaryLoading } from './SaleSummary/SaleSummary';
import OrderCanceled from '../order-canceled/components/OrderCanceled';
import PurchaserInfo from './PurchaserInfo/PurchaserInfo';
import Loading from '../../../../elements/Loading/Loading';
import Modal from '../../../../elements/Modal/Modal';

import style from '../../../reserve/components/Reserve.scss';
import commonStyle from '../../components/OrderCommon.scss';
import icons from '../../../../assets/styles/icons.scss';
// import productStyle from '../../../../elements/Product/Product.scss';

import type { BagItem, Order, OrderItem, ShoppingCartItem } from '../../../../entities';
import type { Match } from '../../../../router';
import type { OrderType } from '../../duck';
import type { HTTPError } from '../../../../error';
import type { Node } from 'react';
import type { Props as ProductProps } from '../../../../elements/Product/Product';
import type { ItemsByStore } from '../../../new-order/QuoteStep/components/QuoteSummary/QuoteSummary';
import type { LocalValuesState } from '../../../local-values/duck';
import type { LocaleState } from '../../../locale/duck';
import type { ProductType } from "../../../../elements/SingleProduct/SingleProduct";

type Item = BagItem | ShoppingCartItem;

type Props = {
  +match: Match;
  +fetchOrder: (orderId: string, orderType: OrderType) => void;
  +isFetchingOrder?: boolean;
  +isProgressingOrder: boolean;
  +order?: Order;
  +localeState: LocaleState;
  +localValues: LocalValuesState;
  +resetState: () => void;
  +resetAlertState: () => void;
  +progressError?: HTTPError;
};

type State = {
  itemsOpen: { [key: string]: boolean };
};

export default class Sale extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // NOTE: By default, the first one is opened
    this.state = {
      itemsOpen: {
        '0': true,
      },
    };
  }

  componentDidMount() {
    const { fetchOrder, order, match } = this.props;
    /*if (!order && match.params) {
      fetchOrder(match.params.id, 'sale');
    }*/
  }

  componentDidUpdate(prevProps: Props) {
    const { progressError, fetchOrder, match } = this.props;
    if (!prevProps.progressError && !!progressError) {
      this.scrollAnimateTop();
    }

    if (prevProps.match.params.id !== match.params.id) {
      fetchOrder(match.params.id, 'sale');
    }
  }

  componentWillUnmount() {
    const { resetAlertState, resetState } = this.props;
    resetAlertState();
    resetState();
  }

  scrollAnimateTop = () =>
    scroll.scrollTo(0, {
      duration: 400,
    });

  handleOrderOpen = (index: number) => {
    this.setState((state: State) => {
      return {
        itemsOpen: update(state.itemsOpen, {
          [`${index}`]: {
            $set: !state.itemsOpen[`${index}`],
          },
        }),
      }
    });
  };

  buildPurchaserInfo = (): Node => {
    const { order } = this.props;
    return (
      <Fragment>
        <FormattedMessage id="order.purchaserInfo.title">{
          txt => <h2 className={commonStyle.title}>{txt}</h2>
        }</FormattedMessage>
        <PurchaserInfo order={order}/>
      </Fragment>
    );
  };

  buildSummary = (): Node => {
    const { order } = this.props;
    return (
      <Fragment>
        <FormattedMessage id="order.info.title">{
          txt => <h2 className={commonStyle.title}>{txt}</h2>
        }</FormattedMessage>
        <SaleSummary order={order}/>
      </Fragment>
    );
  };

  buildProducts = (renderContent?: (props: ProductProps) => Node): Node => {
    const { itemsOpen } = this.state;
    const { localValues, order, localeState } = this.props;
    let idx = -1;
    const itemsByStores: ?ItemsByStore[] = order && groupItems(order.items);
    return (
      <Fragment>
        <FormattedMessage id="order.summary.title">{
          txt => <h2 className={commonStyle.title}>{txt}</h2>
        }</FormattedMessage>
        {itemsByStores && itemsByStores.map((store: ItemsByStore, n: number) =>
          <section key={n}
                   className={commonStyle.storesWrap}>
            <section className={commonStyle.storeInfoWrap}>
              <FormattedMessage id="newOrder.quote.products.soldBy">{
                txt => <span className={commonStyle.storeInfoLabel}>{txt}:</span>
              }</FormattedMessage>
              {store.logo ? <img className={commonStyle.logo}
                                 src={store.logo}
                                 alt={store.name}/> : <span>{store.name}</span>}
              {!store.items.some((item: Item) => item.shipping !== '0.00') &&
              <FormattedMessage id="newOrder.quote.products.free">{
                txt => <span className={commonStyle.free}>
                  <i className={icons.symbolCheck}/>{txt}</span>
              }</FormattedMessage>}
            </section>
            {store.items.map((item: Item) => {
              let productType: ProductType = 'SUCCESS';
              // let renderInvoice: (props: ProductProps) => Node;
              let subtitleIntl: string = 'product.state.success.confirmed';
              if ((item: OrderItem).state === 'CANCELED' || (order &&
                ['BUYER_CANCELED',
                  'TRAVELER_CANCELED',
                  'QEMPO_CANCELED',
                  'QEMPO_CANCELED_FOR_FRAUD'].indexOf(order.state) !== -1)) {
                productType = 'CANCELED';
                subtitleIntl = 'product.state.canceled';
              } else if ((item: OrderItem).state === 'PENDING' && order && order.state === 'RESERVED') {
                if (!!item.externalInvoice) {
                  subtitleIntl = 'product.state.success.uploadInvoice';
                } else {
                  productType = 'VIEW';
                  subtitleIntl = 'product.state.view.pendingUploadInvoice';
                }
              } else if (order && order.state === 'PURCHASED') {
                if ((item: OrderItem).state === 'PENDING') {
                  productType = 'VIEW';
                  subtitleIntl = 'product.state.view.pendingConfirm';
                } else if ((item: OrderItem).state === 'CONFIRMED') {
                  subtitleIntl = 'product.state.success.confirmed';
                }
              }
              idx++;
              return <Product key={idx}
                              index={idx}
                              item={item}
                              open={!!itemsOpen[`${idx}`]}
                              isLoading={false}
                              handleOpen={this.handleOrderOpen}
                              localeState={localeState}
                              categoriesMap={localValues.categoriesMap}
                              type={productType}
                              onlineStore={item.onlineStore}
                              renderContent={(item: OrderItem).state !== 'CANCELED' ? renderContent : undefined}
                              subtitle={subtitleIntl}
                              userType="traveler"/>;
            })}
          </section>)}
      </Fragment>
    );
  };

  getSaleComponent(): ?Node {
    const { isFetchingOrder, order } = this.props;
    if (!order || isFetchingOrder) {
      return;
    }
    switch (order.state) {
      case 'RESERVED':
        return <ReservedContainer buildProducts={this.buildProducts.bind(this)}
                                  buildSummary={this.buildSummary}/>;
      case 'PURCHASED':
        return <PurchasedContainer buildProducts={this.buildProducts.bind(this)}
                                   buildSummary={this.buildSummary}/>;
      case 'BUYER_CANCELED':
      case 'TRAVELER_CANCELED':
      case 'QEMPO_CANCELED':
      case 'QEMPO_CANCELED_FOR_FRAUD':
        return <OrderCanceled buildProducts={this.buildProducts.bind(this)}
                              buildSummary={this.buildSummary}/>;
      case 'RECEIVED':
        return <ReceivedContainer buildProducts={this.buildProducts.bind(this)}
                                  buildSummary={this.buildSummary}
                                  buildPurchaserInfo={this.buildPurchaserInfo.bind(this)}/>;
      case 'ARRIVED':
        return <DeliverContainer buildProducts={this.buildProducts.bind(this)}
                                 buildPurchaserInfo={this.buildPurchaserInfo.bind(this)}
                                 buildSummary={this.buildSummary}/>;
      case 'SHIPPING':
      case 'IN_QEMPO':
      case 'IN_QEMPO_CONFIRMED':
      case 'DELIVERED':
      case 'DELIVERY_CONFIRMED':
        return <CompletedContainer buildProducts={this.buildProducts.bind(this)}
                                   buildSummary={this.buildSummary}
                                   buildPurchaserInfo={this.buildPurchaserInfo.bind(this)}/>;
      default:
        return <p>default</p>;
    }
  }

  render() {
    const { order, isFetchingOrder, isProgressingOrder } = this.props;
    const saleComponent = this.getSaleComponent();
    const loadingComponent =
      <main className={commonStyle.mainWrap}>
        <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
          <FormattedMessage id="order.summary.title">{
            txt => <h2 className={commonStyle.title}>{txt}</h2>
          }</FormattedMessage>
          {[0, 1, 2].map((_, n: number) => <ProductLoading key={n}/>)}
        </section>
        <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
          <FormattedMessage id="order.info.title">{
            txt => <h2 className={commonStyle.title}>{txt}</h2>
          }</FormattedMessage>
          <SaleSummaryLoading/>
        </section>
      </main>;
    return (
      <Fragment>
        {(!order || isFetchingOrder ? loadingComponent : saleComponent)}
        <Modal handleClose={() => undefined}
               open={isProgressingOrder}
               transparent
               maskColor="white"
               showCloseButton={false}>
          <Loading type="circle"
                   color="orange"
                   className={style.loading}/>
        </Modal>
      </Fragment>
    );
  }
}

Sale.propTypes = {
  match: PropTypes.object.isRequired,
  localeState: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  fetchOrder: PropTypes.func.isRequired,
  isFetchingOrder: PropTypes.bool,
  order: PropTypes.object,
  resetState: PropTypes.func.isRequired,
  resetAlertState: PropTypes.func.isRequired,
  progressError: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/modules/order/Sale/components/Sale.jsx